export interface BaseModel {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  instanceVersion: number;
  createdBy: string;
  updatedBy: string;
  metadata: Record<string, unknown>;
}

export abstract class BaseModelClass implements BaseModel {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  instanceVersion: number;
  createdBy: string;
  updatedBy: string;
  metadata: Record<string, unknown>;

  constructor() {
    const now = new Date().toISOString();
    this.id = '';
    this.createdAt = now;
    this.updatedAt = now;
    this.deletedAt = null;
    this.instanceVersion = 0;
    this.createdBy = '';
    this.updatedBy = '';
    this.metadata = {};
  }
}
